import { postRequest } from '../../../shared/utils';

export async function validateFinRepoService(npiId: string, screenGridId: number) {
  const body = {
    columns: ['npi_id'],
    screenGridId,
    schema: 'npi',
    table: 'tblfinancerepository',
    key: 'npi_id',
    value: npiId,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  return data;
}
